import { WASHMEN_CUSTOMER_API } from 'api/config';

export async function updateIntercomIdAPI() {
  await WASHMEN_CUSTOMER_API.put('/customers/intercom-id');
}
